import { chunkData } from "@/app/utils/helperFunctions"
import ConstructionChunks from "./ConstructionChunks"
import { TConstructionCard } from "@/app/types/constructionPageTypes"

const ConstructionList = ({
	data,
	setActiveModal,
	setModalData,
}: {
	data: TConstructionCard[]
	setActiveModal: (value: boolean) => void
    setModalData: (data: TConstructionCard | null) => void
}) => {
	const chunks = chunkData(data.slice(2), 3)
	return (
		<div className="lg:space-y-[4rem]">
			<ConstructionChunks
				data={data.slice(0, 2)}
				key={data.slice(0, 2).length}
				setActiveModal={setActiveModal}
                setModalData={setModalData}
			/>
			{chunks.map((item, index) => (
				<ConstructionChunks
					data={item}
					grids={3}
					indexing={2}
					key={chunks.length + index}
					setActiveModal={setActiveModal}
                    setModalData={setModalData}
				/>
			))}
		</div>
	)
}

export default ConstructionList
